<template>
  <div class="text-h6 text-center text-brand-5 text-weight-bold">
    Enviar Anexos
  </div>
  <div class="row col-12 q-mt-lg">
    <div>
      <div class="text-brand-5 text-weight-bold container">
        Enviar novo Anexo
      </div>
      <label class="btn-adicionar" for="arquivo"> Selecionar Arquivo</label>
      <div class="text-brand-5 text-weight-bold text">
        {{ imageFile && ativo ? imageFile.name : "Nenhum arquivo escolhido" }}
      </div>
      <input
        id="arquivo"
        type="file"
        @change="onFileSelected"
        @click="resetValue()"
      />
      <span class="icon">
        <img src="../../../assets/file_upload_white.svg" alt="" />
      </span>
    </div>
    <div
      class="col-md-4 col-sm-8 col-xs-8 text-brand-5 text-weight-bold q-ml-xl"
    >
      Observação
      <q-input dense outlined v-model="observacao" />
    </div>
    <div class="col-md-2 col-sm-3 col-xs-3 q-ml-sm">
      <p></p>
      <q-btn
        class="q-mt-sm"
        label="Enviar"
        no-caps
        @click="onUpload()"
        icon="check_circle_outline"
        color="positive"
      />
    </div>
  </div>

  <div class="row col-12 q-mt-lg">
    <p class="text-h6 text-brand-5 text-weight-bold">Anexos enviados</p>
    <ul class="col-12">
      <li
        class="text-brand-5"
        v-for="documento in listaDocumentos"
        :key="documento.descricao"
      >
        <div class="row justify-between q-mb-md q-ml-sm items-center">
          <div>
            <p class="text-subtitle1 text-weight-bolder text-brand-5">Anexo</p>
            <div>Observação: {{ documento.observacao }}</div>
            <div>
              Data de Criação:
              {{ documento.data_criacao.split(" ")[1].replace(".000000", " ") }}
            </div>
          </div>
          <div class="q-gutter-x-sm q-mt-xl">
            <a :href="documento.url" download style="text-decoration: none">
              <q-btn
                dense
                no-caps
                label="Baixar Documento"
                icon="file_download"
                color="positive"
              ></q-btn>
            </a>
            <q-btn
              dense
              no-caps
              flat
              label="Excluir Documento"
              icon="delete"
              color="negative"
              @click="deletarDocumento(documento.uuid)"
            ></q-btn>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

export default {
  props: ["uuid", "ferramenta_uuid"],

  setup(props) {
    const $q = useQuasar();
    const store = useStore();
    const imageFile = ref("");
    const imageUrl = ref("");
    const observacao = ref("");
    let ativo = ref(false);

    const listaDocumentos = ref([]);

    const documento = ref({
      uuid: "",
      observacao: "",
      data_criacao: "",
    });

    const formataDataHora = (data_criacao) => {
      const data = data_criacao.split(" ")[0].split("-").reverse().join("/");

      const hora = data_criacao.split(" ")[1].replace(".000000", " ");

      return `${data} ${hora}`;
    };

    let onFileSelected = async (e) => {
      if (e.target.files[0].length === 0) {
        return;
      }

      imageFile.value = e.target.files[0];
      ativo.value = true;
    };

    watch(imageFile, (imageFile) => {
      let fileReader = new FileReader();
      fileReader.readAsDataURL(imageFile);
      fileReader.addEventListener("load", () => {
        imageUrl.value = fileReader.result;
      });
    });

    let onUpload = async () => {
      if (!observacao.value || !imageUrl.value) {
        $q.notify({
          message: "Preencha todos os campos!",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      await store.dispatch("fer/uploadDocumentos", {
        transaction_type: "movimentacao_status",
        transaction_uuid: props.uuid,
        observacao: observacao.value,
        imagem: imageUrl.value,
      });

      mensagem("Arquivo enviado com sucesso!");
      observacao.value = "";
      imageUrl.value = "";
      ativo.value = false;
      return listarDocumentos();
    };

    let listarDocumentos = async () => {
      let resposta = await store.dispatch("fer/listarDocumentos", {
        movimentacao_status_uuid: props.uuid,
      });

      listaDocumentos.value = resposta.listaDocumentos;
    };

    const resetValue = () => {
      const input = document.getElementById("arquivo");
      input.value = null;
    };

    onMounted(() => {
      listarDocumentos();
    });

    let deletarDocumento = async (uuid) => {
      await store.dispatch("fer/deletarDocumentoMovimentacao", {
        uuid: uuid,
      });
      mensagem("Documento excluido com sucesso!");
      listarDocumentos();
    };

    let mensagem = (mensagem) => {
      $q.notify({
        message: mensagem,
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    return {
      listaDocumentos,
      listarDocumentos,
      documento,
      observacao,
      onUpload,
      onFileSelected,
      deletarDocumento,
      mensagem,
      resetValue,
      formataDataHora,
      imageFile,
      ativo,
    };
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
.btn-adicionar {
  display: inline-block;
  background-color: #58afc1;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  margin: 5px 5px 0 0;
  padding: 6px 20px;
  padding-left: 40px;
}
.text {
  display: inline;
}
ul {
  list-style: none;
}
.container {
  position: relative;
}
.icon {
  position: absolute;
  top: 101px;
  left: 24px;
}
</style>
